// Official BCM brand assets — the authoritative supplied files.
//
// Use these exactly as supplied: never redraw, retype, stretch, crop, or
// recolor the artwork. The wordmark is black, so on dark-blue surfaces it is
// placed on a light brand-colored plate rather than being recolored.

export type BrandAssetKey = 'wordmark' | 'logoCompact'

export const brandAssets: Record<BrandAssetKey, string> = {
  /** Full "ucfbcm" wordmark with cross. */
  wordmark: 'https://cdn.magicpatterns.com/uploads/fD3DnAsHNYpyGT7bHKaL1Y/Logo.svg',
  /** Compact cross mark for icons and tight spaces. */
  logoCompact: 'https://cdn.magicpatterns.com/uploads/ne8WMBoiaB36sFSg75rRcw/Other_Logo.svg',
}

/** Plain readable descriptor shown alongside the logo. */
export const brandDescriptor = 'Baptist Collegiate Ministries at UCF'
